import { createSlice } from '@reduxjs/toolkit';
import {
    aguaSaladaNodo,
} from '../actions/aguaSaladaNodo';


export const AguaSaladaReducerNodo = createSlice({
    name: 'aguaSaladaNodo',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(aguaSaladaNodo.pending, (state) => { state.loading = true })
            .addCase(aguaSaladaNodo.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(aguaSaladaNodo.rejected, (state) => { state.loading = false })
    }
})
export default AguaSaladaReducerNodo.reducer;